// import React, { useState, useEffect, useMemo } from 'react';
// import { useNavigate } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import Sidebar from '../Core/Sidebar';
// import Navbar from '../Core/Navbar';
// import { 
//   ArrowLeft, 
//   Wallet, 
//   Search, 
//   Filter, 
//   Download, 
//   ChevronLeft, 
//   ChevronRight,
//   Calendar,
//   ChevronDown,
//   CreditCard,
//   ArrowUpRight,
//   ArrowDownRight
// } from 'lucide-react';
// import '../../Dashboard Style/WalletTransaction.css';
// import * as XLSX from 'xlsx';

// const WalletTransaction = () => {
//   const navigate = useNavigate();
//   const authToken = useSelector((state) => state.user?.token);
//   const [sidebarOpen, setSidebarOpen] = useState(true);
//   const [transactions, setTransactions] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalPages, setTotalPages] = useState(1);
//   const [walletType, setWalletType] = useState('FuelWallet');
//   const [perPage, setPerPage] = useState(15);
//   const [searchQuery, setSearchQuery] = useState('');
//   const [dateFilter, setDateFilter] = useState('all');
//   const [originalTransactions, setOriginalTransactions] = useState([]);


//   const toggleSidebar = () => {
//     setSidebarOpen(!sidebarOpen);
//   };

//   // Initialize sidebar functionality (same as in Dashboard)
//   useEffect(() => {
//     const sidebar = document.querySelector('.sidebar');
//     const sidebarBody = document.querySelector('.sidebar-body');
    
//     if (sidebar) {
//       if (sidebarOpen) {
//         sidebar.classList.remove('close');
//       } else {
//         sidebar.classList.add('close');
//       }
//     }
    
//     // Add custom scrollbar to sidebar body
//     if (sidebarBody) {
//       sidebarBody.style.height = 'calc(100vh - 70px)';
//       sidebarBody.style.overflowY = 'auto';
//     }

//     return () => {
//       // Cleanup
//     };
//   }, [sidebarOpen]);

//   useEffect(() => {
//     // Add custom scrollbar styles for sidebar
//     const style = document.createElement('style');
//     style.innerHTML = `
//       /* Custom scrollbar for sidebar */
//       .sidebar-body {
//         height: calc(100vh - 70px);
//         overflow-y: auto;
//       }
      
//       .sidebar-body::-webkit-scrollbar {
//         width: 6px;
//       }
      
//       .sidebar-body::-webkit-scrollbar-track {
//         background: rgba(255, 255, 255, 0.05);
//         border-radius: 10px;
//       }
      
//       .sidebar-body::-webkit-scrollbar-thumb {
//         background: rgba(255, 255, 255, 0.2);
//         border-radius: 10px;
//       }
      
//       .sidebar-body::-webkit-scrollbar-thumb:hover {
//         background: rgba(255, 255, 255, 0.3);
//       }
      
//       /* Sidebar dropdown menu styles */
//       .sidebar .nav-dropdown {
//         list-style: none;
//         padding-left: 0;
//         max-height: 0;
//         overflow: hidden;
//         transition: max-height 0.3s ease;
//       }
      
//       .sidebar .nav-dropdown.show {
//         max-height: 500px;
//       }
      
//       .sidebar .nav-dropdown-item {
//         padding-left: 2.5rem;
//       }
      
//       /* Sidebar dropdown toggle with icon */
//       .nav-item.has-dropdown .nav-link {
//         position: relative;
//         padding-right: 2.5rem;
//       }
      
//       .nav-item.has-dropdown .dropdown-icon {
//         position: absolute;
//         right: 1rem;
//         top: 50%;
//         transform: translateY(-50%);
//         transition: transform 0.3s ease;
//       }
      
//       .nav-item.has-dropdown .nav-link[aria-expanded="true"] .dropdown-icon {
//         transform: translateY(-50%) rotate(180deg);
//       }
      
//       /* Improved dropdown styling similar to first image */
//       .nav-item.has-dropdown .nav-dropdown {
//         background: rgba(255, 255, 255, 0.05);
//         border-left: 3px solid var(--primary-color, #0d6efd);
//         margin-left: 1rem;
//         border-radius: 0 0 8px 8px;
//       }
      
//       .nav-item.has-dropdown .nav-dropdown-item .nav-link {
//         padding: 0.75rem 1rem 0.75rem 2rem;
//         color: rgba(255, 255, 255, 0.8);
//       }
      
//       .nav-item.has-dropdown .nav-dropdown-item .nav-link:hover {
//         background: rgba(255, 255, 255, 0.1);
//         color: white;
//       }
      
//       /* Fix for category text styling */
//       .nav-item.has-dropdown .link-title.nav-item.nav-category {
//         font-weight: 600;
//         font-size: 0.875rem;
//         text-transform: uppercase;
//         letter-spacing: 0.5px;
//       }
      
//       /* Smooth transitions */
//       .sidebar {
//         transition: all 0.3s ease;
//       }
//     `;
//     document.head.appendChild(style);

//     return () => {
//       document.head.removeChild(style);
//     };
//   }, []);

//   const fetchTransactions = async () => {
//     try {
//       setLoading(true);
//       setError('');

//       const response = await fetch(`https://admin.oceaniabloom9.com/api/user/get-wallet-transaction`, {
//         method: 'POST',
//         headers: {
//           'Authorization': `Bearer ${authToken}`,
//           'Accept': 'application/json',
//           'Content-Type': 'application/x-www-form-urlencoded',
//         },
//         body: new URLSearchParams({
//           wallet_type: walletType,
//           per_page: perPage.toString(),
//           page: currentPage.toString()
//         })
//       });

//       const data = await response.json();

//       if (data.status) {
//         const fetchedTransactions = data.data || [];
//         setOriginalTransactions(fetchedTransactions);
//         setTransactions(fetchedTransactions);
//         setTotalPages(data.pagination?.last_page || 1);
//       } else {
//         setError(data.message || 'Failed to fetch transactions');
//       }
//     } catch (error) {
//       console.error('Error fetching transactions:', error);
//       setError('Failed to load transaction history');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchTransactions();
//   }, [currentPage, walletType, perPage]);

//   // Filter transactions based on search query and date filter
//   const filteredTransactions = useMemo(() => {
//     let filtered = [...originalTransactions];

//     // Apply search filter
//     if (searchQuery.trim()) {
//       const query = searchQuery.toLowerCase();
//       filtered = filtered.filter(transaction => 
//         transaction.transaction_id?.toString().toLowerCase().includes(query) ||
//         transaction.from_user_email?.toLowerCase().includes(query) ||
//         transaction.transaction_type?.toLowerCase().includes(query) ||
//         transaction.opening_bal?.toString().includes(query) ||
//         transaction.credit_bal?.toString().includes(query) ||
//         transaction.debit_bal?.toString().includes(query) ||
//         transaction.closing_bal?.toString().includes(query)
//       );
//     }

//     // Apply date filter
//     if (dateFilter !== 'all') {
//       const now = new Date();
//       filtered = filtered.filter(transaction => {
//         const transactionDate = new Date(transaction.created_at);
        
//         switch (dateFilter) {
//           case 'today':
//             return transactionDate.toDateString() === now.toDateString();
          
//           case 'week': {
//             const oneWeekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
//             return transactionDate >= oneWeekAgo;
//           }
          
//           case 'month': {
//             const oneMonthAgo = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
//             return transactionDate >= oneMonthAgo;
//           }
          
//           case 'year': {
//             const oneYearAgo = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate());
//             return transactionDate >= oneYearAgo;
//           }
          
//           default:
//             return true;
//         }
//       });
//     }

//     return filtered;
//   }, [originalTransactions, searchQuery, dateFilter]);

//   const handleWalletTypeChange = (type) => {
//     setWalletType(type);
//     setCurrentPage(1);
//   };

//   const handleSearch = (e) => {
//     e.preventDefault();
//     // Search is handled by filteredTransactions memo
//   };

//   const handleDownload = () => {
//     // Prepare data for export
//     const exportData = filteredTransactions.map(transaction => ({
//       'Transaction ID': transaction.transaction_id || transaction.id,
//       'Type': getTransactionLabel(transaction.transaction_type),
//       'From/To': transaction.from_user_email || 'System',
//       'Opening Balance': `$${parseFloat(transaction.opening_bal || 0).toFixed(2)}`,
//       'Credit': transaction.credit_bal > 0 ? `$${transaction.credit_bal}` : '',
//       'Debit': transaction.debit_bal > 0 ? `$${transaction.debit_bal}` : '',
//       'Closing Balance': `$${parseFloat(transaction.closing_bal || 0).toFixed(2)}`,
//       'Date & Time': formatDate(transaction.created_at),
//       'Level': transaction.level || 'N/A',
//       'Transaction Type': transaction.transaction_type
//     }));

//     // Create worksheet
//     const ws = XLSX.utils.json_to_sheet(exportData);
    
//     // Create workbook
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, 'Wallet Transactions');
    
//     // Generate filename with timestamp
//     const timestamp = new Date().toISOString().split('T')[0];
//     const filename = `${walletType}_Transactions_${timestamp}.xlsx`;
    
//     // Download file
//     XLSX.writeFile(wb, filename);
//   };

//   const handleDateFilterChange = (filter) => {
//     setDateFilter(filter);
//     setCurrentPage(1);
//   };

//   const formatDate = (dateString) => {
//     const date = new Date(dateString);
//     return date.toLocaleDateString('en-US', {
//       year: 'numeric',
//       month: 'short',
//       day: 'numeric',
//       hour: '2-digit',
//       minute: '2-digit'
//     });
//   };

//   const getTransactionIcon = (type) => {
//     switch (type) {
//       case 'RECEIVED_WALLET':
//         return <ArrowDownRight className="text-green-500" size={16} />;
//       case 'SENT_WALLET':
//         return <ArrowUpRight className="text-red-500" size={16} />;
//       default:
//         return <CreditCard className="text-blue-500" size={16} />;
//     }
//   };

//   const getTransactionColor = (type) => {
//     switch (type) {
//       case 'RECEIVED_WALLET':
//         return 'text-green-500';
//       case 'SENT_WALLET':
//         return 'text-red-500';
//       default:
//         return 'text-blue-500';
//     }
//   };

//   const getTransactionLabel = (type) => {
//     switch (type) {
//       case 'RECEIVED_WALLET':
//         return 'Received';
//       case 'SENT_WALLET':
//         return 'Sent';
//       default:
//         return type?.replace('_', ' ') || 'Other';
//     }
//   };

//   // Calculate stats from filtered transactions
//   const totalReceived = filteredTransactions.reduce((sum, t) => sum + parseFloat(t.credit_bal || 0), 0);
//   const totalSent = filteredTransactions.reduce((sum, t) => sum + parseFloat(t.debit_bal || 0), 0);
//   const currentBalance = filteredTransactions.length > 0 
//     ? parseFloat(filteredTransactions[filteredTransactions.length - 1]?.closing_bal || 0)
//     : 0;

//   return (
//     <div className="main-wrapper dark-theme">
//       {/* Sidebar */}
//       <nav className={`sidebar ${sidebarOpen ? '' : 'close'}`}>
//         <div className="sidebar-header">
//           <a href="#" className="sidebar-brand">
//             <i className="me-2" data-lucide="atom"></i>
//             Willow <span>Quantum</span>
//           </a>
//           <div className="sidebar-toggler" onClick={toggleSidebar}>
//             <span></span>
//             <span></span>
//             <span></span>
//           </div>
//         </div>
//         <Sidebar />
//       </nav>

//       <div className="page-wrapper">
//         {/* Navbar - Update to pass toggleSidebar prop */}
//         <Navbar toggleSidebar={toggleSidebar} />

//         {/* Main Content */}
//         <div 
//           className="page-content wallet-transaction-page"
//           style={{
//             background: 'linear-gradient(to bottom right, rgb(20, 20, 20) 0%, #021e18 25%, rgb(20, 20, 20) 100%)',
//             minHeight: '100vh'
//           }}
//         >
//           <div className="container-fluid py-4">
//             {/* Header */}
//             <div className="row mb-4">
//               <div className="col-12">
//                 <div className="d-flex align-items-center mb-4">
//                   <h1 className="h3 mb-0 text-white">Wallet Transaction History</h1>
//                 </div>
//               </div>
//             </div>

//             {/* Wallet Type Toggle */}
//             <div className="row mb-4">
//               <div className="col-12">
//                 <div className="wallet-type-toggle">
//                   <div className="toggle-buttons">
//                     {['FuelWallet', 'WithdrawalWallet', 'LiquidityWallet'].map((type) => (
//                       <button
//                         key={type}
//                         className={`toggle-btn ${walletType === type ? 'active' : ''}`}
//                         onClick={() => handleWalletTypeChange(type)}
//                       >
//                         <Wallet size={16} className="me-2" />
//                         {type.replace('Wallet', '')}
//                       </button>
//                     ))}
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Stats Overview */}
//             <div className="row mb-4">
//               <div className="col-md-3">
//                 <div className="stat-card">
//                   <div className="stat-icon">
//                     <ArrowDownRight className="text-green-500" size={24} />
//                   </div>
//                   <div className="stat-content">
//                     <div className="stat-label">Total Received</div>
//                     <div className="stat-value">${totalReceived.toFixed(2)}</div>
//                   </div>
//                 </div>
//               </div>
//               <div className="col-md-3">
//                 <div className="stat-card">
//                   <div className="stat-icon">
//                     <ArrowUpRight className="text-red-500" size={24} />
//                   </div>
//                   <div className="stat-content">
//                     <div className="stat-label">Total Sent</div>
//                     <div className="stat-value">${totalSent.toFixed(2)}</div>
//                   </div>
//                 </div>
//               </div>
//               <div className="col-md-3">
//                 <div className="stat-card">
//                   <div className="stat-icon">
//                     <Wallet className="text-blue-500" size={24} />
//                   </div>
//                   <div className="stat-content">
//                     <div className="stat-label">Current Balance</div>
//                     <div className="stat-value">${currentBalance.toFixed(2)}</div>
//                   </div>
//                 </div>
//               </div>
//               <div className="col-md-3">
//                 <div className="stat-card">
//                   <div className="stat-icon">
//                     <CreditCard className="text-purple-500" size={24} />
//                   </div>
//                   <div className="stat-content">
//                     <div className="stat-label">Filtered Transactions</div>
//                     <div className="stat-value">{filteredTransactions.length}</div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Filters and Controls */}
//             <div className="row mb-4">
//               <div className="col-md-8">
//                 <div className="d-flex gap-3 search-filter">
//                   <form onSubmit={handleSearch} className="flex-grow-1">
//                     <div className="search-box">
//                       <Search size={18} className="search-icon" />
//                       <input
//                         type="text"
//                         className="search-input"
//                         placeholder="Search by transaction ID, email, or amount..."
//                         value={searchQuery}
//                         onChange={(e) => setSearchQuery(e.target.value)}
//                       />
//                       {/* <button type="submit" className="search-btn">
//                         Search
//                       </button> */}
//                     </div>
//                   </form>
//                   <div className="dropdown">
//                     <button
//                       className="btn btn-outline-light dropdown-toggle"
//                       type="button"
//                       data-bs-toggle="dropdown"
//                     >
//                       <Filter size={16} className="me-2" />
//                       {dateFilter === 'all' ? 'Filter by Date' : dateFilter.charAt(0).toUpperCase() + dateFilter.slice(1)}
//                     </button>
//                     <div className="dropdown-menu">
//                       <button 
//                         className={`dropdown-item ${dateFilter === 'today' ? 'active' : ''}`}
//                         onClick={() => handleDateFilterChange('today')}
//                       >
//                         Today
//                       </button>
//                       <button 
//                         className={`dropdown-item ${dateFilter === 'week' ? 'active' : ''}`}
//                         onClick={() => handleDateFilterChange('week')}
//                       >
//                         This Week
//                       </button>
//                       <button 
//                         className={`dropdown-item ${dateFilter === 'month' ? 'active' : ''}`}
//                         onClick={() => handleDateFilterChange('month')}
//                       >
//                         This Month
//                       </button>
//                       <button 
//                         className={`dropdown-item ${dateFilter === 'year' ? 'active' : ''}`}
//                         onClick={() => handleDateFilterChange('year')}
//                       >
//                         This Year
//                       </button>
//                       <div className="dropdown-divider"></div>
//                       <button 
//                         className={`dropdown-item ${dateFilter === 'all' ? 'active' : ''}`}
//                         onClick={() => handleDateFilterChange('all')}
//                       >
//                         All Time
//                       </button>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <div className="col-md-4">
//                 <div className="d-flex export-page gap-2">
//                   <button 
//                     className="btn btn-outline-light"
//                     onClick={handleDownload}
//                     disabled={filteredTransactions.length === 0}
//                   >
//                     <Download size={16} className="me-2" />
//                     Export ({filteredTransactions.length})
//                   </button>
//                   <div className="dropdown">
//                     <button
//                       className="btn btn-outline-light dropdown-toggle"
//                       type="button"
//                       data-bs-toggle="dropdown"
//                     >
//                       {perPage} per page
//                     </button>
//                     <div className="dropdown-menu">
//                       {[10, 15, 25, 50, 100].map((num) => (
//                         <button
//                           key={num}
//                           className={`dropdown-item ${perPage === num ? 'active' : ''}`}
//                           onClick={() => setPerPage(num)}
//                         >
//                           {num} per page
//                         </button>
//                       ))}
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Transactions Table */}
//             <div className="row">
//               <div className="col-12">
//                 <div className="transaction-table-wrapper">
//                   {loading ? (
//                     <div className="text-center py-5">
//                       <div className="spinner-border text-light" role="status">
//                         <span className="visually-hidden">Loading...</span>
//                       </div>
//                     </div>
//                   ) : error ? (
//                     <div className="alert alert-danger">{error}</div>
//                   ) : filteredTransactions.length === 0 ? (
//                     <div className="text-center py-5">
//                       <p className="text-white-50">
//                         {searchQuery || dateFilter !== 'all' 
//                           ? 'No transactions found matching your search criteria.' 
//                           : 'No transactions found.'}
//                       </p>
//                       {(searchQuery || dateFilter !== 'all') && (
//                         <button 
//                           className="btn btn-outline-light mt-2"
//                           onClick={() => {
//                             setSearchQuery('');
//                             setDateFilter('all');
//                           }}
//                         >
//                           Clear Filters
//                         </button>
//                       )}
//                     </div>
//                   ) : (
//                     <>
//                       <div className="table-responsive">
//                         <table className="transaction-table">
//                           <thead>
//                             <tr>
//                               <th>Transaction ID</th>
//                               <th>Type</th>
//                               <th>From/To</th>
//                               <th>Opening Balance</th>
//                               <th>Amount</th>
//                               <th>Closing Balance</th>
//                               <th>Date & Time</th>
                              
//                             </tr>
//                           </thead>
//                           <tbody>
//                             {filteredTransactions.map((transaction) => (
//                               <tr key={transaction.id}>
//                                 <td>
//                                   <div className="transaction-id">
//                                     #{transaction.transaction_id || transaction.id}
//                                   </div>
//                                 </td>
//                                 <td>
//                                   <div className={`transaction-type ${getTransactionColor(transaction.transaction_type)}`}>
//                                     {getTransactionIcon(transaction.transaction_type)}
//                                     <span className="ms-2">{getTransactionLabel(transaction.transaction_type)}</span>
//                                   </div>
//                                 </td>
//                                 <td>
//                                   <div className="transaction-email">
//                                     {transaction.from_user_email || 'System'}
//                                   </div>
//                                 </td>
//                                 <td>
//                                   <div className="amount opening">
//                                     ${parseFloat(transaction.opening_bal || 0).toFixed(2)}
//                                   </div>
//                                 </td>
//                                 <td>
//                                   <div className={`amount ${transaction.credit_bal > 0 ? 'credit' : 'debit'}`}>
//                                     {transaction.credit_bal > 0 ? '+' : '-'}$
//                                     {Math.abs(transaction.credit_bal || transaction.debit_bal || 0).toFixed(2)}
//                                   </div>
//                                 </td>
//                                 <td>
//                                   <div className="amount closing">
//                                     ${parseFloat(transaction.closing_bal || 0).toFixed(2)}
//                                   </div>
//                                 </td>
//                                 <td>
//                                   <div className="transaction-date">
//                                     <Calendar size={14} className="me-2" />
//                                     {formatDate(transaction.created_at)}
//                                   </div>
//                                 </td>
                               
//                               </tr>
//                             ))}
//                           </tbody>
//                         </table>
//                       </div>
//                     </>
//                   )}
//                 </div>
//               </div>
//             </div>

//             {/* Summary Section */}
//             <div className="row mt-4">
//               <div className="col-md-6">
//                 <div className="summary-card">
//                   <h5 className="summary-title">Transaction Summary</h5>
//                   <div className="summary-content">
//                     <div className="summary-item">
//                       <span className="summary-label">Filtered Transactions:</span>
//                       <span className="summary-value">{filteredTransactions.length}</span>
//                     </div>
//                     <div className="summary-item">
//                       <span className="summary-label">Total Received:</span>
//                       <span className="summary-value text-green-500">
//                         ${totalReceived.toFixed(2)}
//                       </span>
//                     </div>
//                     <div className="summary-item">
//                       <span className="summary-label">Total Sent:</span>
//                       <span className="summary-value text-red-500">
//                         ${totalSent.toFixed(2)}
//                       </span>
//                     </div>
//                     <div className="summary-item">
//                       <span className="summary-label">Net Change:</span>
//                       <span className={`summary-value ${(totalReceived - totalSent) >= 0 ? 'text-green-500' : 'text-red-500'}`}>
//                         ${(totalReceived - totalSent).toFixed(2)}
//                       </span>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//               <div className="col-md-6">
//                 <div className="info-card">
//                   <h5 className="info-title">Filter Information</h5>
//                   <div className="info-content">
//                     <div className="info-item">
//                       <span className="info-label">Wallet Type:</span>
//                       <span className="info-value">{walletType}</span>
//                     </div>
//                     <div className="info-item">
//                       <span className="info-label">Date Filter:</span>
//                       <span className="info-value">{dateFilter === 'all' ? 'All Time' : dateFilter}</span>
//                     </div>
//                     <div className="info-item">
//                       <span className="info-label">Search Query:</span>
//                       <span className="info-value">{searchQuery || 'None'}</span>
//                     </div>
//                     <div className="info-item">
//                       <span className="info-label">Last Updated:</span>
//                       <span className="info-value">{new Date().toLocaleString()}</span>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Footer */}
//         <footer className="footer-dark">
//           <div className="container">
//             <p className="text-center mb-0 text-white">
//               Copyright © 2025 Willow Quantum. All rights reserved.
//             </p>
//           </div>
//         </footer>
//       </div>
//     </div>
//   );
// };

// export default WalletTransaction;

import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import Sidebar from '../Core/Sidebar';
import Navbar from '../Core/Navbar';
import { 
  ArrowLeft, 
  Wallet, 
  Search, 
  Filter, 
  Download, 
  ChevronLeft, 
  ChevronRight,
  Calendar,
  ChevronDown,
  CreditCard,
  ArrowUpRight,
  ArrowDownRight
} from 'lucide-react';
import '../../Dashboard Style/WalletTransaction.css';
import * as XLSX from 'xlsx';
import { toast } from 'react-toastify'; // Import toast

const WalletTransaction = () => {
  const navigate = useNavigate();
  const authToken = useSelector((state) => state.user?.token);
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [transactions, setTransactions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [walletType, setWalletType] = useState('FuelWallet');
  const [perPage, setPerPage] = useState(15);
  const [searchQuery, setSearchQuery] = useState('');
  const [dateFilter, setDateFilter] = useState('all');
  const [originalTransactions, setOriginalTransactions] = useState([]);


  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  // Initialize sidebar functionality (same as in Dashboard)
  useEffect(() => {
    const sidebar = document.querySelector('.sidebar');
    const sidebarBody = document.querySelector('.sidebar-body');
    
    if (sidebar) {
      if (sidebarOpen) {
        sidebar.classList.remove('close');
      } else {
        sidebar.classList.add('close');
      }
    }
    
    // Add custom scrollbar to sidebar body
    if (sidebarBody) {
      sidebarBody.style.height = 'calc(100vh - 70px)';
      sidebarBody.style.overflowY = 'auto';
    }

    return () => {
      // Cleanup
    };
  }, [sidebarOpen]);

  useEffect(() => {
    // Add custom scrollbar styles for sidebar
    const style = document.createElement('style');
    style.innerHTML = `
      /* Custom scrollbar for sidebar */
      .sidebar-body {
        height: calc(100vh - 70px);
        overflow-y: auto;
      }
      
      .sidebar-body::-webkit-scrollbar {
        width: 6px;
      }
      
      .sidebar-body::-webkit-scrollbar-track {
        background: rgba(255, 255, 255, 0.05);
        border-radius: 10px;
      }
      
      .sidebar-body::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 10px;
      }
      
      .sidebar-body::-webkit-scrollbar-thumb:hover {
        background: rgba(255, 255, 255, 0.3);
      }
      
      /* Sidebar dropdown menu styles */
      .sidebar .nav-dropdown {
        list-style: none;
        padding-left: 0;
        max-height: 0;
        overflow: hidden;
        transition: max-height 0.3s ease;
      }
      
      .sidebar .nav-dropdown.show {
        max-height: 500px;
      }
      
      .sidebar .nav-dropdown-item {
        padding-left: 2.5rem;
      }
      
      /* Sidebar dropdown toggle with icon */
      .nav-item.has-dropdown .nav-link {
        position: relative;
        padding-right: 2.5rem;
      }
      
      .nav-item.has-dropdown .dropdown-icon {
        position: absolute;
        right: 1rem;
        top: 50%;
        transform: translateY(-50%);
        transition: transform 0.3s ease;
      }
      
      .nav-item.has-dropdown .nav-link[aria-expanded="true"] .dropdown-icon {
        transform: translateY(-50%) rotate(180deg);
      }
      
      /* Improved dropdown styling similar to first image */
      .nav-item.has-dropdown .nav-dropdown {
        background: rgba(255, 255, 255, 0.05);
        border-left: 3px solid var(--primary-color, #0d6efd);
        margin-left: 1rem;
        border-radius: 0 0 8px 8px;
      }
      
      .nav-item.has-dropdown .nav-dropdown-item .nav-link {
        padding: 0.75rem 1rem 0.75rem 2rem;
        color: rgba(255, 255, 255, 0.8);
      }
      
      .nav-item.has-dropdown .nav-dropdown-item .nav-link:hover {
        background: rgba(255, 255, 255, 0.1);
        color: white;
      }
      
      /* Fix for category text styling */
      .nav-item.has-dropdown .link-title.nav-item.nav-category {
        font-weight: 600;
        font-size: 0.875rem;
        text-transform: uppercase;
        letter-spacing: 0.5px;
      }
      
      /* Smooth transitions */
      .sidebar {
        transition: all 0.3s ease;
      }
    `;
    document.head.appendChild(style);

    return () => {
      document.head.removeChild(style);
    };
  }, []);

  const fetchTransactions = async () => {
    try {
      setLoading(true);
      setError('');

      const response = await fetch(`https://admin.oceaniabloom9.com/api/user/get-wallet-transaction`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${authToken}`,
          'Accept': 'application/json',
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: new URLSearchParams({
          wallet_type: walletType,
          per_page: perPage.toString(),
          page: currentPage.toString()
        })
      });

      const data = await response.json();

      if (data.status) {
        const fetchedTransactions = data.data || [];
        setOriginalTransactions(fetchedTransactions);
        setTransactions(fetchedTransactions);
        setTotalPages(data.pagination?.last_page || 1);
        toast.success('Transactions loaded successfully');
      } else {
        const errorMessage = data.message || 'Failed to fetch transactions';
        setError(errorMessage);
        toast.error(errorMessage);
      }
    } catch (error) {
      console.error('Error fetching transactions:', error);
      const errorMessage = 'Failed to load transaction history';
      setError(errorMessage);
      toast.error(errorMessage);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, [currentPage, walletType, perPage]);

  // Filter transactions based on search query and date filter
  const filteredTransactions = useMemo(() => {
    let filtered = [...originalTransactions];

    // Apply search filter
    if (searchQuery.trim()) {
      const query = searchQuery.toLowerCase();
      filtered = filtered.filter(transaction => 
        transaction.transaction_id?.toString().toLowerCase().includes(query) ||
        transaction.from_user_email?.toLowerCase().includes(query) ||
        transaction.transaction_type?.toLowerCase().includes(query) ||
        transaction.opening_bal?.toString().includes(query) ||
        transaction.credit_bal?.toString().includes(query) ||
        transaction.debit_bal?.toString().includes(query) ||
        transaction.closing_bal?.toString().includes(query)
      );
    }

    // Apply date filter
    if (dateFilter !== 'all') {
      const now = new Date();
      filtered = filtered.filter(transaction => {
        const transactionDate = new Date(transaction.created_at);
        
        switch (dateFilter) {
          case 'today':
            return transactionDate.toDateString() === now.toDateString();
          
          case 'week': {
            const oneWeekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);
            return transactionDate >= oneWeekAgo;
          }
          
          case 'month': {
            const oneMonthAgo = new Date(now.getFullYear(), now.getMonth() - 1, now.getDate());
            return transactionDate >= oneMonthAgo;
          }
          
          case 'year': {
            const oneYearAgo = new Date(now.getFullYear() - 1, now.getMonth(), now.getDate());
            return transactionDate >= oneYearAgo;
          }
          
          default:
            return true;
        }
      });
    }

    return filtered;
  }, [originalTransactions, searchQuery, dateFilter]);

  const handleWalletTypeChange = (type) => {
    setWalletType(type);
    setCurrentPage(1);
    toast.info(`Switched to ${type}`);
  };

  const handleSearch = (e) => {
    e.preventDefault();
    // Search is handled by filteredTransactions memo
  };

  const handleDownload = () => {
    // Prepare data for export
    const exportData = filteredTransactions.map(transaction => ({
      'Transaction ID': transaction.transaction_id || transaction.id,
      'Type': getTransactionLabel(transaction.transaction_type),
      'From/To': transaction.from_user_email || 'System',
      'Opening Balance': `$${parseFloat(transaction.opening_bal || 0).toFixed(2)}`,
      'Credit': transaction.credit_bal > 0 ? `$${transaction.credit_bal}` : '',
      'Debit': transaction.debit_bal > 0 ? `$${transaction.debit_bal}` : '',
      'Closing Balance': `$${parseFloat(transaction.closing_bal || 0).toFixed(2)}`,
      'Date & Time': formatDate(transaction.created_at),
      'Level': transaction.level || 'N/A',
      'Transaction Type': transaction.transaction_type
    }));

    // Create worksheet
    const ws = XLSX.utils.json_to_sheet(exportData);
    
    // Create workbook
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Wallet Transactions');
    
    // Generate filename with timestamp
    const timestamp = new Date().toISOString().split('T')[0];
    const filename = `${walletType}_Transactions_${timestamp}.xlsx`;
    
    // Download file
    XLSX.writeFile(wb, filename);
    toast.success('Transactions exported successfully');
  };

  const handleDateFilterChange = (filter) => {
    setDateFilter(filter);
    setCurrentPage(1);
    toast.info(`Date filter changed to ${filter === 'all' ? 'All Time' : filter}`);
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      hour: '2-digit',
      minute: '2-digit'
    });
  };

  const getTransactionIcon = (type) => {
    switch (type) {
      case 'RECEIVED_WALLET':
        return <ArrowDownRight className="text-green-500" size={16} />;
      case 'SENT_WALLET':
        return <ArrowUpRight className="text-red-500" size={16} />;
      default:
        return <CreditCard className="text-blue-500" size={16} />;
    }
  };

  const getTransactionColor = (type) => {
    switch (type) {
      case 'RECEIVED_WALLET':
        return 'text-green-500';
      case 'SENT_WALLET':
        return 'text-red-500';
      default:
        return 'text-blue-500';
    }
  };

  const getTransactionLabel = (type) => {
    switch (type) {
      case 'RECEIVED_WALLET':
        return 'Received';
      case 'SENT_WALLET':
        return 'Sent';
      default:
        return type?.replace('_', ' ') || 'Other';
    }
  };

  // Calculate stats from filtered transactions
  const totalReceived = filteredTransactions.reduce((sum, t) => sum + parseFloat(t.credit_bal || 0), 0);
  const totalSent = filteredTransactions.reduce((sum, t) => sum + parseFloat(t.debit_bal || 0), 0);
  const currentBalance = filteredTransactions.length > 0 
    ? parseFloat(filteredTransactions[filteredTransactions.length - 1]?.closing_bal || 0)
    : 0;

  return (
    <div className="main-wrapper dark-theme">
      {/* Sidebar */}
      <nav className={`sidebar ${sidebarOpen ? '' : 'close'}`}>
        <div className="sidebar-header">
          <a href="#" className="sidebar-brand">
            <i className="me-2" data-lucide="atom"></i>
            Willow <span>Quantum</span>
          </a>
          <div className="sidebar-toggler" onClick={toggleSidebar}>
            <span></span>
            <span></span>
            <span></span>
          </div>
        </div>
        <Sidebar />
      </nav>

      <div className="page-wrapper">
        {/* Navbar - Update to pass toggleSidebar prop */}
        <Navbar toggleSidebar={toggleSidebar} />

        {/* Main Content */}
        <div 
          className="page-content wallet-transaction-page"
          style={{
            background: 'linear-gradient(to bottom right, rgb(20, 20, 20) 0%, #021e18 25%, rgb(20, 20, 20) 100%)',
            minHeight: '100vh'
          }}
        >
          <div className="container-fluid py-4">
            {/* Header */}
            <div className="row mb-4">
              <div className="col-12">
                <div className="d-flex align-items-center mb-4">
                  <h1 className="h3 mb-0 text-white">Wallet Transaction History</h1>
                </div>
              </div>
            </div>

            {/* Wallet Type Toggle */}
            <div className="row mb-4">
              <div className="col-12">
                <div className="wallet-type-toggle">
                  <div className="toggle-buttons">
                    {['FuelWallet', 'WithdrawalWallet', 'LiquidityWallet'].map((type) => (
                      <button
                        key={type}
                        className={`toggle-btn ${walletType === type ? 'active' : ''}`}
                        onClick={() => handleWalletTypeChange(type)}
                      >
                        <Wallet size={16} className="me-2" />
                        {type.replace('Wallet', '')}
                      </button>
                    ))}
                  </div>
                </div>
              </div>
            </div>

            {/* Stats Overview */}
            <div className="row mb-4">
              <div className="col-md-3">
                <div className="stat-card">
                  <div className="stat-icon">
                    <ArrowDownRight className="text-green-500" size={24} />
                  </div>
                  <div className="stat-content">
                    <div className="stat-label">Total Received</div>
                    <div className="stat-value">${totalReceived.toFixed(2)}</div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="stat-card">
                  <div className="stat-icon">
                    <ArrowUpRight className="text-red-500" size={24} />
                  </div>
                  <div className="stat-content">
                    <div className="stat-label">Total Sent</div>
                    <div className="stat-value">${totalSent.toFixed(2)}</div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="stat-card">
                  <div className="stat-icon">
                    <Wallet className="text-blue-500" size={24} />
                  </div>
                  <div className="stat-content">
                    <div className="stat-label">Current Balance</div>
                    <div className="stat-value">${currentBalance.toFixed(2)}</div>
                  </div>
                </div>
              </div>
              <div className="col-md-3">
                <div className="stat-card">
                  <div className="stat-icon">
                    <CreditCard className="text-purple-500" size={24} />
                  </div>
                  <div className="stat-content">
                    <div className="stat-label">Filtered Transactions</div>
                    <div className="stat-value">{filteredTransactions.length}</div>
                  </div>
                </div>
              </div>
            </div>

            {/* Filters and Controls */}
            <div className="row mb-4">
              <div className="col-md-8">
                <div className="d-flex gap-3 search-filter">
                  <form onSubmit={handleSearch} className="flex-grow-1">
                    <div className="search-box">
                      <Search size={18} className="search-icon" />
                      <input
                        type="text"
                        className="search-input"
                        placeholder="Search by transaction ID, email, or amount..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                      />
                      {/* <button type="submit" className="search-btn">
                        Search
                      </button> */}
                    </div>
                  </form>
                  <div className="dropdown">
                    <button
                      className="btn btn-outline-light dropdown-toggle"
                      type="button"
                      data-bs-toggle="dropdown"
                    >
                      <Filter size={16} className="me-2" />
                      {dateFilter === 'all' ? 'Filter by Date' : dateFilter.charAt(0).toUpperCase() + dateFilter.slice(1)}
                    </button>
                    <div className="dropdown-menu">
                      <button 
                        className={`dropdown-item ${dateFilter === 'today' ? 'active' : ''}`}
                        onClick={() => handleDateFilterChange('today')}
                      >
                        Today
                      </button>
                      <button 
                        className={`dropdown-item ${dateFilter === 'week' ? 'active' : ''}`}
                        onClick={() => handleDateFilterChange('week')}
                      >
                        This Week
                      </button>
                      <button 
                        className={`dropdown-item ${dateFilter === 'month' ? 'active' : ''}`}
                        onClick={() => handleDateFilterChange('month')}
                      >
                        This Month
                      </button>
                      <button 
                        className={`dropdown-item ${dateFilter === 'year' ? 'active' : ''}`}
                        onClick={() => handleDateFilterChange('year')}
                      >
                        This Year
                      </button>
                      <div className="dropdown-divider"></div>
                      <button 
                        className={`dropdown-item ${dateFilter === 'all' ? 'active' : ''}`}
                        onClick={() => handleDateFilterChange('all')}
                      >
                        All Time
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-4">
                <div className="d-flex export-page gap-2">
                  <button 
                    className="btn btn-outline-light"
                    onClick={handleDownload}
                    disabled={filteredTransactions.length === 0}
                  >
                    <Download size={16} className="me-2" />
                    Export ({filteredTransactions.length})
                  </button>
                  <div className="dropdown">
                    <button
                      className="btn btn-outline-light dropdown-toggle"
                      type="button"
                      data-bs-toggle="dropdown"
                    >
                      {perPage} per page
                    </button>
                    <div className="dropdown-menu">
                      {[10, 15, 25, 50, 100].map((num) => (
                        <button
                          key={num}
                          className={`dropdown-item ${perPage === num ? 'active' : ''}`}
                          onClick={() => {
                            setPerPage(num);
                            toast.info(`Displaying ${num} transactions per page`);
                          }}
                        >
                          {num} per page
                        </button>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Transactions Table */}
            <div className="row">
              <div className="col-12">
                <div className="transaction-table-wrapper">
                  {loading ? (
                    <div className="text-center py-5">
                      <div className="spinner-border text-light" role="status">
                        <span className="visually-hidden">Loading...</span>
                      </div>
                    </div>
                  ) : error ? (
                    <div className="alert alert-danger">{error}</div>
                  ) : filteredTransactions.length === 0 ? (
                    <div className="text-center py-5">
                      <p className="text-white-50">
                        {searchQuery || dateFilter !== 'all' 
                          ? 'No transactions found matching your search criteria.' 
                          : 'No transactions found.'}
                      </p>
                      {(searchQuery || dateFilter !== 'all') && (
                        <button 
                          className="btn btn-outline-light mt-2"
                          onClick={() => {
                            setSearchQuery('');
                            setDateFilter('all');
                            toast.info('Filters cleared');
                          }}
                        >
                          Clear Filters
                        </button>
                      )}
                    </div>
                  ) : (
                    <>
                      <div className="table-responsive">
                        <table className="transaction-table">
                          <thead>
                            <tr>
                              <th>Transaction ID</th>
                              <th>Type</th>
                              <th>From/To</th>
                              <th>Opening Balance</th>
                              <th>Amount</th>
                              <th>Closing Balance</th>
                              <th>Date & Time</th>
                              
                            </tr>
                          </thead>
                          <tbody>
                            {filteredTransactions.map((transaction) => (
                              <tr key={transaction.id}>
                                <td>
                                  <div className="transaction-id">
                                    #{transaction.transaction_id || transaction.id}
                                  </div>
                                </td>
                                <td>
                                  <div className={`transaction-type ${getTransactionColor(transaction.transaction_type)}`}>
                                    {getTransactionIcon(transaction.transaction_type)}
                                    <span className="ms-2">{getTransactionLabel(transaction.transaction_type)}</span>
                                  </div>
                                </td>
                                <td>
                                  <div className="transaction-email">
                                    {transaction.from_user_email || 'System'}
                                  </div>
                                </td>
                                <td>
                                  <div className="amount opening">
                                    ${parseFloat(transaction.opening_bal || 0).toFixed(2)}
                                  </div>
                                </td>
                                <td>
                                  <div className={`amount ${transaction.credit_bal > 0 ? 'credit' : 'debit'}`}>
                                    {transaction.credit_bal > 0 ? '+' : '-'}$
                                    {Math.abs(transaction.credit_bal || transaction.debit_bal || 0).toFixed(2)}
                                  </div>
                                </td>
                                <td>
                                  <div className="amount closing">
                                    ${parseFloat(transaction.closing_bal || 0).toFixed(2)}
                                  </div>
                                </td>
                                <td>
                                  <div className="transaction-date">
                                    <Calendar size={14} className="me-2" />
                                    {formatDate(transaction.created_at)}
                                  </div>
                                </td>
                               
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>
                    </>
                  )}
                </div>
              </div>
            </div>

            {/* Summary Section */}
            <div className="row mt-4">
              <div className="col-md-6">
                <div className="summary-card">
                  <h5 className="summary-title">Transaction Summary</h5>
                  <div className="summary-content">
                    <div className="summary-item">
                      <span className="summary-label">Filtered Transactions:</span>
                      <span className="summary-value">{filteredTransactions.length}</span>
                    </div>
                    <div className="summary-item">
                      <span className="summary-label">Total Received:</span>
                      <span className="summary-value text-green-500">
                        ${totalReceived.toFixed(2)}
                      </span>
                    </div>
                    <div className="summary-item">
                      <span className="summary-label">Total Sent:</span>
                      <span className="summary-value text-red-500">
                        ${totalSent.toFixed(2)}
                      </span>
                    </div>
                    <div className="summary-item">
                      <span className="summary-label">Net Change:</span>
                      <span className={`summary-value ${(totalReceived - totalSent) >= 0 ? 'text-green-500' : 'text-red-500'}`}>
                        ${(totalReceived - totalSent).toFixed(2)}
                      </span>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="info-card">
                  <h5 className="info-title">Filter Information</h5>
                  <div className="info-content">
                    <div className="info-item">
                      <span className="info-label">Wallet Type:</span>
                      <span className="info-value">{walletType}</span>
                    </div>
                    <div className="info-item">
                      <span className="info-label">Date Filter:</span>
                      <span className="info-value">{dateFilter === 'all' ? 'All Time' : dateFilter}</span>
                    </div>
                    <div className="info-item">
                      <span className="info-label">Search Query:</span>
                      <span className="info-value">{searchQuery || 'None'}</span>
                    </div>
                    <div className="info-item">
                      <span className="info-label">Last Updated:</span>
                      <span className="info-value">{new Date().toLocaleString()}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <footer className="footer-dark">
          <div className="container">
            <p className="text-center mb-0 text-white">
              Copyright © 2025 Willow Quantum. All rights reserved.
            </p>
          </div>
        </footer>
      </div>
    </div>
  );
};

export default WalletTransaction;